import { initializeBurgerMenu } from './js/burgerLogic';
import './css/style.scss';

document.querySelectorAll('#link').forEach(link => {
  link.addEventListener('click', function () {
    const panel = this.firstElementChild;

    panel.classList.toggle('hidden');
  });
});

const form = document.getElementById('contact-form');
const notif = document.getElementById('notification');

form?.addEventListener('submit', event => {
  event.preventDefault();
  notif.classList.remove('hidden');

  setTimeout(() => {
    notif.classList.add('hidden');
    form.reset();
  }, 3000);
});
